// Copyright (c) 2017 Deere & Company

import ReimbursementSummaryDetails from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.reimbursementSummary.details,
    columnApi: state.columnApi,
    gridApi: state.gridApi,
    isDefaultColumnStateAvailable: state.reportVariant.layouts.length ? Boolean(state.reportVariant.layouts.find(layout => layout.name === '').columnState.length) : false,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    layouts: state.reportVariant.layouts,
    report: state.reimbursementSummary.summary.leadAccounts,
    selectedLayout: state.reportVariant.selectedLayout
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    queryParams: parentProps.location.query,
    showAllAccounts: true
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ReimbursementSummaryDetails);



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/all-accounts.js